import React, { Component } from 'react';
import '../styles/loader.css'
import $ from 'jquery'
class Loader extends Component {

    constructor(props) {
        super(props);
        this.handleLoad = this.handleLoad.bind(this);
    }

    componentDidMount() {
        window.addEventListener('load', this.handleLoad);
    }

    handleLoad() {
        $("#loaderlayer").remove();
     }

    render() {
        return (
            <div >
                <div className="layer" id="loaderlayer">
                    <div className="wrap">
                        <div className="loading">
                            <div className="bounceball"></div>
                            <div className="text">NOW LOADING</div>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>

        )
    }
}
export default Loader
